import { Modal, ModalBody, ModalContent, ModalOverlay } from "@chakra-ui/modal";
import Card from "components/card";

const ConfirmModal = (props: {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    title: string;
    description: string | React.ReactNode;
    confirmText?: string;
    cancelText?: string;
    confirmColor?: string;
    isWarning?: boolean;
    extraAction?: {
        label: string;
        onClick: () => void;
        color?: string;
    };
}) => {
    const {
        isOpen,
        onClose,
        onConfirm,
        title,
        description,
        confirmText = "Confirmer",
        cancelText = "Annuler",
        confirmColor = "bg-[#0260CB]",
        isWarning = false,
        extraAction,
    } = props;

    const handleConfirm = () => {
        onConfirm();
        onClose();
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay className="bg-[#000] !opacity-30" />
            <ModalContent className="!z-[1002] !m-auto !w-max min-w-[350px] !max-w-[85%] top-[12vh]">
                <ModalBody>
                    <Card extra="px-[30px] pt-[35px] pb-[40px] max-w-[650px] flex flex-col !z-[1004]">
                        <h1 className={`mb-[20px] text-2xl font-bold ${isWarning ? 'text-orange-600' : ''}`}>
                            {isWarning && '⚠️ '}{title}
                        </h1>
                        <div className="text-base text-gray-700 dark:text-gray-300">
                            {description}
                        </div>
                        <div className="mt-5 flex flex-wrap gap-2 mx-auto">
                            <button
                                onClick={onClose}
                                className="linear rounded-xl border-2 border-gray-700 px-5 py-3 text-base font-medium text-gray-700 transition duration-200 hover:bg-gray-600/5 active:bg-gray-700/5 dark:border-gray-400 dark:bg-gray-400/10 dark:text-white dark:hover:bg-gray-300/10 dark:active:bg-gray-200/10"
                            >
                                {cancelText}
                            </button>
                            {extraAction && (
                                <button
                                    className={`linear rounded-xl ${extraAction.color || 'bg-[#0260CB]'} px-5 py-3 text-base font-medium text-white transition duration-200 hover:opacity-90 active:opacity-80`}
                                    onClick={() => { extraAction.onClick(); onClose(); }}
                                >
                                    {extraAction.label}
                                </button>
                            )}
                            <button
                                className={`linear col-span-12 ml-3 flex items-center justify-center rounded-xl ${confirmColor} px-5 py-3 text-base font-medium text-white transition duration-200 hover:opacity-90 active:opacity-80`}
                                onClick={handleConfirm}
                            >
                                {confirmText}
                            </button>
                        </div>
                    </Card>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};

export default ConfirmModal;
